<template>
  <div>
    <div class="listItem">
      <slot></slot>
    </div>
  </div>
</template>
<style lang="less" scoped>
.listItem {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.08);
  opacity: 1;
  border-radius: 4px;
  margin-top: 20px;
  // padding: 0 18px 0 12px;

  .listChild {
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(230, 230, 230, 1);
    .childName {
      font-size: 13px;
      min-width: 80px;
      text-align: left;
      font-weight: 400;
      line-height: 35px;
      color: rgba(0, 130, 164, 1);
    }
    .chilDetail {
      margin-left: 20px;
      font-size: 13px;
      font-weight: 400;
      line-height: 35px;
      color: rgba(51, 51, 51, 1);
    }
  }
}
</style>
<script>
export default {
  name: "ListDetailCont"
};
</script>
